import React, {useState, useEffect, useCallback} from 'react'
import {withRouter} from 'react-router-dom'
import Swal from 'sweetalert2'

import { PageContainer } from '../../components/register/Container'
import { PreRegistroSection } from '../../components/register/PreRegistroSection/Section'
import { FormRegister } from '../../components/register/FormularioSection/Form'
const initialState = {
    curso:'',
    nombres:'',
    apellidos:'',
    documento_de_identidad:'',
    edad:'',
    direccion:'',
    correo_electronico:'',
    celular:'',
    barrio:'',
    discapacidad:'',
    terminosCondiciones:'',
}
const RegisterScreen = (props) => {
    let API_URL = 'http://formacionartesbosa.upn.edu.co/services/'
    // let API_URL = 'http://localhost:9596/'
    // *************************************useState
    const [alreadyId, setAlreadyId] = useState([])
    const [homeCourse, setHomeCourse] = useState('')
    const [imgToUpload, setImgToUpload] = useState(null)
    const [formValues, setFormValues] = useState(initialState)
    const {
        curso,
        nombres,
        apellidos,
        documento_de_identidad,
        edad,
        direccion,
        correo_electronico,
        celular,
        barrio,
        discapacidad,
        terminosCondiciones,
        } = formValues
    // *************************************useCallback
    const callIds = useCallback((data)=>{
        let dataArray = data.map(event=>event.documento_de_identidad)
        setAlreadyId(dataArray)
    },[setAlreadyId])
    // *************************************useCallback
    // *************************************useEffect
    useEffect(()=>{
        // let API_URL = 'http://formacionartesbosa.upn.edu.co/services/'
        // let API_URL = 'http://localhost:9596/services/'
        // Fetch ID student from server
        // const getData = async()=>{
        //     try{
        //         let fetchData = await fetch(`${API_URL}documento_de_identidad`)
        //         let data = await fetchData.json()
        //         callIds(data)
        //     } catch(error){
        //         console.log(error)
        //         Swal.fire({
        //             icon:'error',
        //             title:'Error',
        //             text:`Algo ha salido mal...`
        //         })
        //     }
        // }
        // getData()
        // Fetch course from home
        let courseDataHome = props.location.state
        console.log(courseDataHome)
        setHomeCourse(courseDataHome.course)
        setFormValues({
            curso: courseDataHome.trimCourse
        })
    },[callIds, props.location.state])
    // *************************************************handle image
    const handleImage = (event)=>{
        let imageStored = event.target.files[0] 
        if(imageStored.size < 3000000){
            setImgToUpload(imageStored)
        }else if(imageStored.size > 3000000){
            Swal.fire({
                icon:'warning',
                text:'La imagen es muy pesada, debe ser de 3MB por mucho'
            })
            setImgToUpload(null)
        }
    }
    // *************************************************handle image
    // *************************************************handle input change
    const handleInputChange = ({target})=>{
        setFormValues({
            ...formValues,
            [target.name]: target.value
        })
    }
    // *************************************************handle input change
    // ************************************************handle submit
    const handleSubmit = async(event)=>{
        event.preventDefault()
        if(alreadyId.indexOf(documento_de_identidad) >= 0){
            Swal.fire({
                icon:'warning',
                text:'Este documento de identidad ya se encuentra registrado en un curso'
            })
        }else {
            const newStudent = JSON.stringify({
                curso,
                nombres,
                apellidos,
                documento_de_identidad,
                edad,
                direccion,
                correo_electronico,
                celular,
                barrio,
                discapacidad,
                terminosCondiciones,
                imgToUpload
            })
            const formData = new FormData()
            formData.append('file', imgToUpload)
            formData.set('data',newStudent)

            const settings = {method:'POST', body:formData}

            try{
                await fetch(`${API_URL}upload-register`, settings)
                Swal.fire({
                    icon:'success',
                    title:'Registro exitoso',
                    text:'En los próximos días se publicarán los listados de los estudiantes aceptados',
                    showConfirmButton: false,
                })
                props.history.push('/')
            } catch(error){
                console.log(error)
                Swal.fire({
                    icon:'error',
                    title:'Error',
                    text:'No se pudo realizar el registro',
                })
            }
        }
    }
    // ************************************************handle submit
    return (
        <PageContainer>
            <PreRegistroSection 
                title='Formulario de Pre-Registro'
                subTitle='Diligencie la siguiente información para su pre-inscripción al curso'
                courseTitle={`Nombre del curso: « ${homeCourse} »`}/>
            <FormRegister 
                onSubmit={handleSubmit}
                defaultName={nombres}
                onChangeName={handleInputChange}
                defaultLastname={apellidos}
                onChangeLastname={handleInputChange}
                defaultIdDocument={documento_de_identidad}
                onChangeIdDocument={handleInputChange}
                defaultAge={edad}
                onChangeAge={handleInputChange}
                defaultAddress={direccion}
                onChangeAddress={handleInputChange}
                defaultEmail={correo_electronico}
                onChangeEmail={handleInputChange}
                defaultPhone={celular}
                onChangePhone={handleInputChange}
                defaultNeighborhood={barrio}
                onChangeNeighborhood={handleInputChange}
                onChangeDisability={handleInputChange}
                onChangeImage={handleImage}
                fileName={imgToUpload !== null ? imgToUpload.name :'Adjunte recibo de servicio público o certificado de residencia'}
                OnChangeTermns={handleInputChange}/>
        </PageContainer>
    )
}
export default withRouter(RegisterScreen)